(() => {
  document.addEventListener('click', event => {
    const thumbnail = event.target.closest('.product-gallery__thumbnail[data-media-id]');
    if (!thumbnail || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const section = thumbnail.closest('[data-section-type="product"]');
    const mapping = section?.querySelector('[data-be-variant-media]');
    if (!mapping) return;
    let variants;
    try { variants = JSON.parse(mapping.textContent); } catch { return; }
    const candidates = variants.filter(variant => String(variant.media) === thumbnail.dataset.mediaId);
    if (!candidates.length) return;
    const form = section.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const currentId = form.querySelector('[name="id"]')?.value;
    if (candidates.some(variant => String(variant.id) === currentId)) return;
    const selectors = [...form.querySelectorAll('.product-form__single-selector')];
    const selectedOptions = [1, 2, 3].map(position => selectors.find(input => Number(input.dataset.optionPosition) === position && (input.tagName === 'SELECT' || input.checked))?.value);
    const ranked = candidates.map(variant => ({variant, score: variant.options.reduce((score, value, index) => score + Number(value === selectedOptions[index]), 0)})).sort((a, b) => b.score - a.score);
    if (ranked.length > 1 && ranked[0].score === ranked[1].score) return;
    const variant = ranked[0].variant;
    if (variant.options.length === 1) {
      const selector = selectors.find(input => Number(input.dataset.optionPosition) === 1 && (input.tagName === 'SELECT' || input.value === variant.options[0]));
      if (!selector) return;
      if (selector.tagName === 'SELECT') selector.value = variant.options[0];
      else selector.checked = true;
      selector.dispatchEvent(new Event('change', {bubbles: true}));
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    const destination = new URL(form.dataset.beProductUrl, window.location.origin);
    destination.searchParams.set('variant', variant.id);
    window.location.assign(destination.href);
  }, true);
})();
